import { Nullable } from "sonobello.utilities.react";

/** Specific datum drawn from the user's answered medical history. */
interface IMedicalConclusions {
  /** A flag indicating that the user has a history of cancer treatment, and may have areas of their body exposed to
   * radiation that the business will not operate on.
   */
  hasRadiationProtectedAreas: Nullable<boolean>;
  /** A flag indicating that the user has a pacemaker lacking defibrillator capabilities, which will need to be
   * confirmed and cleared at any scheduled consult.
   */
  hasPacemakerWithoutDefibrillator: Nullable<boolean>;
  /** A flag indicating that the user has diabetes, and their a1c will need to be confirmed and cleared at any scheduled
   * consult.
   */
  hasDiabetes: Nullable<boolean>;
}

/** A default implementation of {@link IMedicalConclusions} with all values set to `null`. */
export class NullMedicalConclusions implements IMedicalConclusions {
  hasRadiationProtectedAreas: Nullable<boolean>;
  hasPacemakerWithoutDefibrillator: Nullable<boolean>;
  hasDiabetes: Nullable<boolean>;

  constructor() {
    this.hasRadiationProtectedAreas = null;
    this.hasPacemakerWithoutDefibrillator = null;
    this.hasDiabetes = null;
  }
}

export default IMedicalConclusions;
